module.exports = __webpack_public_path__ + "img/yousa.40024ae9.jpg";